import {
  Card,
  CaptionedImage,
  ClassicCard,
  ControlCard,
  ImageOnly,
} from "../index.js";
import {
  dateFromUnixTimestamp as V,
  rehydrateDateAfterJsonization as Q,
} from "../../util/date-utils.js";
import { logger as N } from "../../../shared-lib/index.js";
export function newCard(e, n, r, t, i, o, l, u, d, a, f, s, w, m, p, C, c, x) {
  let j;
  if (n === Card.rs.oi || n === Card.rs.ai)
    j = new ClassicCard(e, r, t, i, o, l, u, d, a, f, s, w, m, p, c, x);
  else if (n === Card.rs.es)
    j = new CaptionedImage(e, r, t, i, o, l, u, d, a, f, s, w, m, p, c, x);
  else if (n === Card.rs.Ii)
    j = new ImageOnly(e, r, i, l, u, d, f, s, w, m, p, c, x);
  else {
    if (n !== Card.rs.Ni)
      return N.error("Ignoring card with unknown type " + n), null;
    j = new ControlCard(e, r, l, u, s, w);
  }
  return C && (j.test = C), j;
}
export function newCardFromContentCardsJson(e) {
  if (e[Card.ui.Ei]) return null;
  const n = e[Card.ui.os],
    r = e[Card.ui.ss],
    t = e[Card.ui.cs],
    i = e[Card.ui.ns],
    o = e[Card.ui.ds],
    l = e[Card.ui.ps],
    u = V(e[Card.ui.us]);
  let d;
  d = e[Card.ui.ls] === Card.Ti ? null : V(e[Card.ui.ls]);
  return newCard(
    n,
    r,
    t,
    i,
    o,
    l,
    u,
    d,
    e[Card.ui.URL],
    e[Card.ui.fs],
    e[Card.ui.xs],
    e[Card.ui.bs],
    e[Card.ui.gs],
    e[Card.ui.js],
    e[Card.ui.zs],
    e[Card.ui.vs] || !1,
    e[Card.ui.ks],
    e[Card.ui.qs],
  );
}
export function newCardFromSerializedValue(e) {
  return (
    newCard(
      e[Card.hs.os],
      e[Card.hs.ss],
      e[Card.hs.cs],
      e[Card.hs.ns],
      e[Card.hs.ds],
      e[Card.hs.ps],
      Q(e[Card.hs.us]),
      Q(e[Card.hs.ls]),
      e[Card.hs.URL],
      e[Card.hs.fs],
      e[Card.hs.xs],
      e[Card.hs.bs],
      e[Card.hs.gs],
      e[Card.hs.js],
      e[Card.hs.zs],
      e[Card.hs.vs] || !1,
      e[Card.hs.ks],
      e[Card.hs.qs],
    ) || void 0
  );
}
